import SortObjectTypes from './sort-object-types'
const { SERIE } = SortObjectTypes
import SortSettingsView from './sort-settings-view'
import i18n from 'scoreboard/components/i18n'

const SerieBarSortSettingsView = SortSettingsView.extend({
	sortObjectType: SERIE,

	/**
	 * @constructs
	 *
	 * @param {Object} options - see SortSettingsView for superclass options
	 *
	 * @param {String} options.axis - the axis that these settings are for
	 */
	initialize: function(options = {}) {
		SortSettingsView.prototype.initialize.apply(this, arguments)
		this.axis = this.options.axis
		this.label = i18n.get('charts.sort.barSorting')
	},

	/**
	 * @override
	 */
	display: function () {
		// #48421 only makes sense to sort bar series when there are
		// multiple series
		return this.chart.barSeriesCount({ axis: this.axis }) > 1
	}
})

export default SerieBarSortSettingsView

SerieBarSortSettingsView.__filename__ = 'charts/edit/sort/serie-bar-sort-settings-view.js'
